/*
MediaSpotStatus is a class-based component that fetches media spot information and passes it down to the SpotStatus component.

1. It is called in Media.js in Spot Status tab
2. It has a default date range filter from today to seven days from today.
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createSelector } from "reselect";
import * as constants from "../../../../../constants";
import { bindDispatch } from "../../../../../utils";
import WithFetchList from "../../../../hoc/withFetchList";
import SpotStatus from "../../common/SpotStatus";
import getSpotStatusDefaultDateRange from "../../utils/getSpotStatusDefaultDateRange";

class MediaSpotStatus extends Component {
  componentDidMount = async () => {
    const {
      match: {
        params: { mediaId },
      },
      campaigns,
    } = this.props;

    const campaign = campaigns?.campaign;
    const defaultRange = getSpotStatusDefaultDateRange("media", campaign);

    this.props.fetchData(null, true, [
      { mediaId },
      {
        filters: [
          {
            from: defaultRange.from,
            id: "showDate",
            type: "showDate",
            displayName: defaultRange.displayName,
            to: defaultRange.to,
          },
        ],
      },
    ]);
  };

  render = () => {
    const {
      media: { isTabLoading, mediaSpots },
    } = this.props;
    return (
      <SpotStatus
        {...this.props}
        data={{
          spotStatus: mediaSpots,
          isLoading: isTabLoading,
        }}
      />
    );
  };
}

export const MediaSpotStatusWithFilters = WithFetchList("getMediaSpots", {
  sort: [
    {
      id: "showDate",
      desc: false,
    },
  ],
  ps: constants.DEFAULT_PAGE_SIZE,
  page: 1,
  multiColumnSort: false,
})(MediaSpotStatus);

const mapStateToProps = createSelector(
  (state) => state.media,
  (state) => state.userData,
  (state) => state.campaigns,

  (media, userData, campaigns) => ({
    media,
    campaigns,
    userData: userData.user,
    userTimeZone:
      userData.user?.user?.preferredTimeZone ?? userData.user?.company?.preferredTimeZone ?? null,
  })
);

export default connect(mapStateToProps, bindDispatch)(withRouter(MediaSpotStatusWithFilters));
